export const taskStatusToText = (status) => {
    status = parseInt(status)
    switch(status){
        case 1:
            return "Ziyaret Edildi"
        case 2:
            return "Kişiye Ulaşılamadı"
        case 3:
            return "Ziyaret Kabul Edilmedi"
    }
}
